import { HYDRATION_KEY } from './constants/index.js';
import { getAppKey } from './utils.js';
export function getHydrationPoint() {
    if (!window[HYDRATION_KEY]) {
        window[HYDRATION_KEY] = {};
    }
    return window[HYDRATION_KEY];
}
export function getAppHydration(manifest, appParamsHelper) {
    if (appParamsHelper) {
        const hydrationId = getAppKey(manifest, appParamsHelper);
        const hydrationPoint = getHydrationPoint();
        return hydrationPoint && hydrationPoint.appsByKey && hydrationPoint.appsByKey[hydrationId];
    }
}
export function getManagerHydration() {
    const hydrationPoint = getHydrationPoint();
    return hydrationPoint && hydrationPoint.manager;
}
//# sourceMappingURL=hydration.js.map